/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
	$( ".Product__Slideshow .Product__SlideItem" ).clone(true).appendTo( ".slide-placeholder" );
});


	window.VIG = window.VIG || {};
	VIG.loaded = false;
	VIG.VariantChangeCallback = function(){
		var visible_ids = $('.slide-placeholder img:visible').map(function() {
			return $(this).data('image-id');
		}).get();


		var slidesToAdd = [];


		visible_ids.forEach(function(element) {
		slidesToAdd.push($('.slide-placeholder [data-image-id='+element+']').closest('.Product__SlideItem'));
		});
		
		//$('.Product__Slideshow').flickity( 'remove', $('.Product__Slideshow .Product__SlideItem') );
		//slidesToAdd.forEach(function(element) {
	//	$('.Product__Slideshow').flickity( 'append', element.clone(true)); 
	//	});
/* Alternate code for filtering the slider */
    var $sliders = $('.Product__Slideshow.flickity-enabled');
    	$sliders.each(function() {
      var $slider = $(this);
      var $sliderInstance = Flickity.data(this);
      if ($sliderInstance != undefined ) {
 			$sliderInstance.remove($('.Product__Slideshow .Product__SlideItem'));
       // var index = $('[data-image-id="' + variant.featured_image.id + '"]').data('index');
       // $sliderInstance.select( index, false, true );
			console.log(slidesToAdd);
			slidesToAdd.forEach(function(element) {
             
			  $sliderInstance.append(element.clone(true));
			});
      }
      else{
		console.log('slider instance undefined');
	  }

	 
    });		
/* Alternate code ends here */
 $('.Product__SlideshowNavScroller img:visible:first').click(); 
    }